import http from "./http_common";

class SharePaymentLinkServices {
  queryString(payload) {
    const QueryString = Object.keys(payload)
      .map((key) => key && payload[key] && key + "=" + payload[key])
      .join("&");
    return QueryString;
  }

  patientPaymentDetails(data) {
    return http.get(`/shareLinkTransaction/list/filter?transactionId=${data}`);
  }

  GetAppointmentId(id) {
    return http.get(`invitationDetails/list/filter?appointmentId=${id}`);
  }

  AppointmentUpdate(data) {
    return http.put(`/invitationDetails/update-status/${data.id}`, data);
  }

  PhonepeTransaction(data) {
    return http.post(`phonepeTransaction/`, data);
  }

  BillingTransaction(data) {
    return http.post(`billingTransaction/`, data);
  }

  initiatePayment(payload) {
    return http.post("/phonePeResponse1/phonepe/payment-initiate", payload);
  }
}

export default new SharePaymentLinkServices();
